export default function Footer() {
  return (
    <footer className="bg-[#2A2318] py-16">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center space-y-8">
          <img
            src="https://static.readdy.ai/image/5676cecc8bee6a08ffa3da23e35cdc4e/ad5d3f8bf6374bd02eaa07bb6e1bfa08.png"
            alt="The GodPadel™ Logo"
            className="h-20 w-auto object-contain"
          />

          <div className="text-center space-y-3">
            <h3 className="font-serif text-2xl font-bold text-[#E5C478]">
              The GodPadel™
            </h3>
            <p className="text-[#F0E1C2]/80 text-lg">
              Premium Indoor Padel Club Concept
            </p>
            <p className="text-[#F0E1C2]/60">
              United Kingdom
            </p>
          </div>

          <div className="w-24 h-px bg-[#B78A44]/40"></div>

          <div className="flex flex-col items-center gap-4 text-sm text-[#F0E1C2]/60">
            <p>© {new Date().getFullYear()} The GodPadel™. All rights reserved.</p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#E5C478] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
